<template>
    <ScrollStrip label="Choose a table" prev-label="Show earlier tables" next-label="Show more tables">
        <button
            v-for="entry in tables"
            :key="entry.id"
            type="button"
            class="snap-start shrink-0 flex items-center gap-2 h-12 px-4 rounded-full border-[1.5px] transition focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary-700"
            :class="entry.selected ? 'bg-primary-50 border-primary' : 'bg-white border-gray-400'"
            :aria-pressed="entry.selected"
            :aria-label="`${entry.name}, ${entry.note}`"
            @click="$emit('select', entry.index)"
        >
            <span class="text-base font-semibold" :class="entry.selected ? 'text-primary-900' : 'text-gray-800'">
                {{ entry.name }}
            </span>
            <span class="text-sm font-semibold" :class="entry.selected ? 'text-primary-800' : 'text-gray-600'">
                {{ entry.note }}
            </span>
        </button>
    </ScrollStrip>
</template>

<script setup>
    import ScrollStrip from "./ScrollStrip.vue";

    defineProps({
        tables: Array,
    });

    defineEmits(["select"]);
</script>
